import { fetchConToken } from "../helpers/fetch"
import { armarParametrosAdicciones } from "../helpers/parametros"; 

const AdiccionesService = {
  //SOLICITUD
  getSolicitudesAuditoria: (
    idAfiliado,
    idCodNom,
    idSolicitud,
    fechaDesde,
    fechaHasta,
    idEstadoSolicitud
  ) => {
    return fetchConToken(
      `SolicitudAdicciones/traerAuditoria?${armarParametrosAdicciones(
        idAfiliado,
        fechaDesde,
        fechaHasta,
        idSolicitud,
        idEstadoSolicitud,
        idCodNom
      )}`
    );
  },
  getContadoresSolicitudesAdicciones: (
    idAfiliado,
    idCodNom,
    idSolicitud,
    fechaDesde,
    fechaHasta) => {
    return fetchConToken(
      `SolicitudAdicciones/traerContadores?${armarParametrosAdicciones(
        idAfiliado,
        fechaDesde,
        fechaHasta,
        idSolicitud,
        null,
        idCodNom
      )}`
    );
  },
  postSolicitud: (data) => {
    return fetchConToken(`SolicitudAdicciones`, data, "POST");
  },
  putSolicitud: (data) => {
    return fetchConToken(`SolicitudAdicciones`, data, "PUT");
  },
  putCancelarSolicitud: (data) => {
    return fetchConToken(`SolicitudAdicciones/cancelarSolicitud`, data, "PUT");
  },
  putEstadoSolicitud: (data) => {
    return fetchConToken(`SolicitudAdicciones/modificarEstado`, data, "PUT");
  },
  anularPeriodo: (idSolicitud, periodo) => {
    return fetchConToken(`SolicitudAdicciones/AnularPeriodo/${idSolicitud}/${periodo}`, {}, 'PUT')
  },
  generatePdfPorIdSolicitudAdicciones: (
    idSolicitud,
    idEstadoSolicitud
  ) => {
    return fetchConToken(
      `SolicitudAdicciones/exportPdfSolicitud?${armarParametrosAdicciones(
        null,
        null,
        null,
        idSolicitud,
      )}`
    );
  },
  //PRACTICAS
  postPracticas: (data) => {
    return fetchConToken(`PracticaSolicitudAdicciones`, data, "POST");
  },
  //PERIODO
  putPeriodos: (data) => {
    return fetchConToken(`PeriodoSolicitudAdicciones`, data, 'PUT');
  },
  //TRACKING SOLICITUD
  getTrackingSolicitudAdicciones: (idSolicitud) => {
    return fetchConToken(
      `TrackingSolicitudAdicciones/traerPorSolicitud/${idSolicitud}`
    );
  },
  //NOTAS SOLICITUD
  postNota: (data, method) => {
    if (method === "POST")
      return fetchConToken(`NotasSolicitudAdicciones`, data, "POST");
    else {
      return fetchConToken(`NotasSolicitudAdicciones/${data.idNota}`, data, "PUT");
    }
  },
  getNotas: (idSolicitud) => {
    return fetchConToken(`NotasSolicitudAdicciones/traerPorSolicitud/${idSolicitud}`);
  },
  deleteNota: (data) => {
    return fetchConToken(`NotasSolicitudAdicciones`, data, "DELETE");
  },
  //AUGO-GESTION
  getMisSolicitudesAdicciones: (idAfiliado, idEstado) => {
    return fetchConToken(`SolicitudAdicciones/traerPorAfiliado?idAfiliado=${idAfiliado}&idEstado=${idEstado}`)
  },
  //TIPO SOLICITUD
  getTiposSolicitudes: () => {
    return fetchConToken(`TipoSolicitudAdicciones`)
  },
  //TIPO DOCUMENTACION
  getAllTiposDocumentacionAdicciones: () => {
    return fetchConToken(`TipoDocumentacionAdicciones`);
  },
  postTipoDocumentacionAdicciones: (data) => {
    return fetchConToken(`TipoDocumentacionAdicciones`, data, "POST");
  },
  putTipoDocumentacionAdicciones: (data) => {
    return fetchConToken(`TipoDocumentacionAdicciones`, data, "PUT");
  },
  deleteTipoDocumentacionAdicciones: (id) => {
    return fetchConToken(`TipoDocumentacionAdicciones/${id}`, {}, "DELETE");
  },
  //TIPO DOCUMENTACION SOLICITUD
  getTiposDocumentacionSolicitudAdicciones: (idTipoSolicitud) => {
    return fetchConToken(`TipoDocumentacionSolicitudAdicciones/traerPorTipoSolicitud/${idTipoSolicitud}`);
  },
  getAllTiposDocumentacionSolicitudAdicciones: () => {
    return fetchConToken(`TipoDocumentacionSolicitudAdicciones`);
  },
  postTipoDocumentacionSolicitudAdicciones: (data) => {
    return fetchConToken(`TipoDocumentacionSolicitudAdicciones`, data, "POST");
  },
  putTipoDocumentacionSolicitudAdicciones: (data) => {
    return fetchConToken(`TipoDocumentacionSolicitudAdicciones`, data, "PUT");
  },
  deleteTipoDocumentacionSolicitudAdicciones: (id) => {
    return fetchConToken(`TipoDocumentacionSolicitudAdicciones/${id}`, {}, "DELETE");
  },
  //DOCUMENTACION SOLICITUD
  getDocumentacionSolicitudAdicciones: (idSolicitud) => {
    return fetchConToken(`DocumentacionSolicitudAdicciones/${idSolicitud}`);
  },
  deleteDocumentacionSolicitudAdicciones: (idDocumento) => {
    return fetchConToken(
      `DocumentacionSolicitudAdicciones/${idDocumento}`,
      {},
      "DELETE"
    );
  },
  //SOLICITUDES TOMADAS
  getSolicitudesTomadasPorUsuario: () => {
    return fetchConToken(`SolicitudesAdiccionesTomadas/traerPorUsuario`);
  },
  getSolicitudesTomadas: () => {
    return fetchConToken(`SolicitudesAdiccionesTomadas/traerTomadas`);
  },
  putLiberarSolicitud: (id) => {
    return fetchConToken(`SolicitudesAdiccionesTomadas`, { id }, "PUT");
  },
  postTomarSolicitud: (idSolicitud) => {
    return fetchConToken(`SolicitudesAdiccionesTomadas`, { idSolicitud }, "POST");
  },
  //CONSUMO AFILIADO
  getConsumosAfiliados: (idAfiliado) => {
    return fetchConToken(
      `SolicitudAdicciones/TraerConsumosAfiliado/${idAfiliado}`
    );
  },

  /*
  traerNomencladorIntegracion: (codigoNombre) => {
    return fetchConToken(`NomencladorIntegracion?codigoNombre=${codigoNombre}`);
  }
    */
}
export { AdiccionesService as default }